<script>
    import Fa from "svelte-fa";
    import { faLock, faQrcode, faUser } from '@fortawesome/free-solid-svg-icons'
    import QRious from "qrious";
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher } from "svelte";
    import Button from "../ui/Button.svelte";
    
    export let device;

    var qr = new QRious({
        background: 'white',
        foreground: 'black',
        level: 'H',
        size: 300,
        value: device.dynamic_link
    });
    let imgSrc = qr.toDataURL();

    function cancel() {
        open = false;
    }

    export let open = false;
</script>


<Dialog class="dialog" open={open} on:close={cancel}>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">Login für {device.name}</DialogTitle>
        <DialogDescription class="dialog-description">
            Scanne folgenden Login-QR-Code mit dem Gerät, dass du verwenden möchtest um es einzuloggen.
            Falls die Kamera deines Geräts nicht funktioniert kannst du alternativ auch die Logindaten verwenden.
        </DialogDescription>

        <div class="login-options">
            <div class="qr">
                {#if device.dynamic_link}
                    <img src={imgSrc} alt="Anmeldecode für {device.name}">
                {/if}
            </div>
            <div class="login">
                <span>
                    <b>
                        <Fa icon={faUser}/>
                        Account
                    </b>
                </span><br>
                <span>
                    {device.email}
                </span><br>
                <br>
                <span>
                    <b>
                        <Fa icon={faLock}/>
                        Passwort
                    </b>
                </span><br>
                <span>
                    {device.pw}
                </span>
            </div>
        </div>

        <div class="dialog-options">
            <Button type="button" on:click={cancel}>
                Schließen
            </Button>
            <Button type="button" intent="primary" on:click={cancel}>
                Fertig
            </Button>
        </div>
    </div>
</Dialog>

<Button transparent on:click={() => {open = true}}>
    <Fa icon={faQrcode} slot="icon"/>
</Button>


<style>
    .login-options {
        display: flex;
        gap: 1rem;
        align-items: center;
        flex-wrap: wrap;
    }
</style>